// extracted by mini-css-extract-plugin
export default {"modeContainer":"voucher-form_modeContainer__LRy-4","maxCountContainer":"voucher-form_maxCountContainer__Zhnaw","generate":"voucher-form_generate__EuwT9"};